import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-loader',
  standalone: true,
  template: `
    <div
      class="hon-loader"
      [class.hon-loader--page]="variant === 'page'"
      [class.hon-loader--block]="variant === 'block'"
      role="status"
      aria-live="polite"
    >
      <span class="hon-loader__spin" aria-hidden="true"></span>
      @if (message) {
        <span class="hon-loader__text">{{ message }}</span>
      }
    </div>
  `,
})
export class PageLoaderComponent {
  @Input() message = 'Loading…';
  @Input() variant: 'page' | 'block' = 'block';
}
